import { Outlet } from "react-router-dom";

import { FilterRewardEventProvider } from "./filter-reward-event/filter-reward-event.context";
import './reward-event.scss';

export function RewardEvent() {
  return (
    <div id="ShellRewardEvent" className="reward-event">
       <FilterRewardEventProvider>
        <Outlet />
      </FilterRewardEventProvider>
    </div>
  );
}

export default RewardEvent;
